module.exports = __webpack_public_path__ + "img/permissions_site.60c2a2be.jpg";